import { GOOGLE_CLICK_ID_REGEX } from '../constants';

export const getGoogleClickIdFromCookie = (): string | undefined => {
  const result = document.cookie.match(GOOGLE_CLICK_ID_REGEX);

  if (result) {
    return result[1];
  }
};
